import React, { useEffect, useState } from 'react';
import styles from './CustomNameInput.module.css';
import { ClientMonitoredTiktokAudioRelationship } from '@round/api';
import useNonNullContext from '../../../../../Hooks/useNonNullContext';
import { OptionsContext } from '../../../../../contexts/Options';

type CustomNameProps = {
    clientMonitoredAudioRelationship: ClientMonitoredTiktokAudioRelationship;
    readonly?: boolean;
    onSubmit?: (newCustomName: ClientMonitoredTiktokAudioRelationship) => void;
};

const CustomNameInput = ({ clientMonitoredAudioRelationship, readonly, onSubmit }: CustomNameProps) => {
    const { clients } = useNonNullContext(OptionsContext);
    const [customNameInputValue, setCustomNameInputValue] = useState(clientMonitoredAudioRelationship.custom_name);
    const handleSubmit = () => {
        if (typeof onSubmit !== 'function' || customNameInputValue === clientMonitoredAudioRelationship.custom_name) {
            return;
        }

        onSubmit({ ...clientMonitoredAudioRelationship, custom_name: customNameInputValue });
    };

    useEffect(() => {
        setCustomNameInputValue(clientMonitoredAudioRelationship.custom_name);
    }, [clientMonitoredAudioRelationship.custom_name]);

    return (
        <div className={styles.container}>
            {readonly ? (
                <span className={styles.customName}>{clientMonitoredAudioRelationship.custom_name}</span>
            ) : (
                <input
                    className={styles.customName}
                    value={customNameInputValue}
                    onChange={(e) => setCustomNameInputValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSubmit();
                        }
                    }}
                    onBlur={handleSubmit}
                />
            )}
            {clients.length > 1 && (
                <span className={styles.clientName}>
                    {clients.find((client) => client.id === clientMonitoredAudioRelationship.client_id)?.name}
                </span>
            )}
        </div>
    );
};

export default CustomNameInput;
